import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import {
  PageSection,
  AvailabilitySlotTypeProvider,
} from '@product-framework/index';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../../utils/getSPLevelStackableButtons';
import LiveCalendar from '../../../../components/Availability/LiveCalendar';

function LiveCalendarPage() {
  const { serviceProviderId, locationId } = useServiceProvider();
  const navigate = useNavigate();

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_AVAILABILITY_LIVE_CALENDAR"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        label={
          <FormattedMessage
            id="SERVICE_PROVIDER_LOCATION_AVAILABILITY_LIVE_CALENDAR"
            defaultMessage="Service Provider Location Availability - Live Calendar"
          />
        }>
        <AvailabilitySlotTypeProvider>
          <LiveCalendar
            serviceProviderId={serviceProviderId}
            locationId={locationId}
          />
        </AvailabilitySlotTypeProvider>
      </PageSection>
    </ServiceProviderLayout>
  );
}

const LiveCalendarPageObserver = observer(LiveCalendarPage);
export default withServiceProvider(LiveCalendarPageObserver);
